import { Flex, Box } from "rebass/styled-components";
import { useStepByStepState } from "./StepByStepContext";
import Icon from "../common/Icon";

const StepCounter = () => {
  const { flow, active } = useStepByStepState();
  return (
    <Box width={1} px={[0, 2, 0]} pb={4}>
      <Flex
        width={1}
        justifyContent="space-between"
        sx={{ position: "relative" }}
      >
        <Box
          width={1}
          height={0}
          sx={{
            position: "absolute",
            border: "1px solid",
            borderColor: "darkGray",
            top: "50%",
            transform: "translateY(-50%)"
          }}
        />
        {Array.from(flow.keys()).map(val => (
          <Box
            key={val}
            className={(val == active && "active") || (val < active && "done")}
            sx={{
              position: "relative",
              zIndex: 1,
              color: "darkGray",
              width: "26px",
              border: "2px solid",
              borderRadius: "circle",
              borderColor: val <= active ? "samoyedWhite" : "darkGray",
              textAlign: "center",
              backgroundColor: "samoyedWhite",
              "&.active": { backgroundColor: "pugYellow", color: "initial" },
              "&.done": { backgroundColor: "springGreen", color: "initial" }
            }}
          >
            {val >= active ? (
              val + 1
            ) : (
              <Box
                sx={{
                  top: "50%",
                  left: "50%",
                  fontSize: "8px",
                  position: "absolute",
                  transform: "translate3d(-50%,-40%,0)",
                  textAlign: "center"
                }}
              >
                <Icon name="check" />
              </Box>
            )}
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default StepCounter;
